import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobApplyHeroComponent } from './job-apply-hero/job-apply-hero.component';
import { JobApplySidebarComponent } from './job-apply-sidebar/job-apply-sidebar.component';
import { JobApplyFormComponent } from './job-apply-form/job-apply-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LanguageRoutingService } from '../../services/language-routing.service';
import { JobService } from '../../services/job.service';
import { Job } from '../../models/job.model';

@Component({
  selector: 'app-job-apply',
  standalone: true,
  imports: [CommonModule, JobApplyHeroComponent, JobApplySidebarComponent, JobApplyFormComponent, TranslocoModule],
  templateUrl: './job-apply.component.html',
  styleUrls: ['./job-apply.component.scss'],
})
export class JobApplyComponent implements OnInit {
  jobId: string | null = null;
  job: Job | undefined;
  loading: boolean = true;
  error: string | null = null;
  matchScore: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private languageRoutingService: LanguageRoutingService,
    private jobService: JobService,
    private translocoService: TranslocoService
  ) {}

  getLocalizedRoute(path: string): string {
    return this.languageRoutingService.getLocalizedRoute(path);
  }

  ngOnInit(): void {
    // Read matchScore from query parameters (optional - from recommended jobs)
    this.route.queryParamMap.subscribe((queryParams) => {
      const scoreParam = queryParams.get('matchScore');
      if (scoreParam) {
        const parsedScore = parseFloat(scoreParam);
        // Validate score is between 0 and 1
        this.matchScore = !isNaN(parsedScore) && parsedScore >= 0 && parsedScore <= 1 ? parsedScore : null;
      } else {
        this.matchScore = null;
      }
    });

    this.route.paramMap.subscribe((params) => {
      this.jobId = params.get('id');
      if (this.jobId) {
        this.fetchJobDetails(this.jobId);
      }
    });
  }

  private fetchJobDetails(jobId: string): void {
    this.loading = true;
    this.error = null;

    this.jobService.getJobById(jobId).subscribe({
      next: (job) => {
        this.job = job;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching job details:', err);
        this.error = this.translocoService.translate('jobApply.loadError');
        this.loading = false;
      }
    });
  }

  /**
   * Called when user edits their profile during job application
   * Removes matchScore from URL as it's no longer accurate
   */
  onProfileEdit(): void {
    // Remove matchScore query param since profile has changed
    this.matchScore = null;

    // Update URL without matchScore
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { matchScore: null },
      queryParamsHandling: 'merge',
      replaceUrl: true // Replace current URL in history
    });
  }
}
